import useLocalize from '../../../utils/hooks/useLocalize';
import SectionHeaderComponent from '../SectionHeaderComponent';
import './SummarySection.scss';

const ChartSection = () => {
  const localize = useLocalize();
  const title = localize('symbol.details.chart.section.title');
  return (
    <div className="summary-section">
      <SectionHeaderComponent title={title} />
      <div className="summary-section-content">
        {/* Chart content will be added in future stories */}
      </div>
    </div>
  );
};

export default ChartSection;
